import { Switch } from "@headlessui/react";
import { PremiumFeature } from "../premium-feature";

export default function UpdatableBoolean(props: {
  title?: string;
  titleClassName?: string;
  value: boolean;
  readOnly?: boolean;
  hasToPay?: boolean;
  onSave: (value: boolean) => void;
}) {
  return (
    <div className="text-sm sm:gap-4 flex sm:items-center sm:pt-6 ">
      <label
        htmlFor="carrier"
        className={`self-center block text-sm font-medium text-gray-700 ${
          props.titleClassName ? props.titleClassName : ""
        }`}
      >
        {props.title}
      </label>

      <div className="sm:col-span-2 flex text-gray-900">
        <div className="flex-1 my-1 ">
          <Switch
            checked={props.value}
            onChange={(value) => props.onSave(value)}
            className={`
            ${
              props.value && !props.readOnly && !props.hasToPay
                ? "bg-purple-600"
                : "bg-gray-200"
            } ${
              props.readOnly || props.hasToPay
                ? "pointer-events-none"
                : "cursor-pointer"
            } relative inline-flex flex-shrink-0 h-6 w-11 border-2 border-transparent rounded-full  transition-colors ease-in-out duration-200 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-purple-500`}
          >
            <span className="sr-only">Use setting</span>
            <span
              className={`
              ${
                props.value ? "translate-x-5" : "translate-x-0"
              } pointer-events-none relative inline-block h-5 w-5 rounded-full bg-white shadow transform ring-0 transition ease-in-out duration-200`}
            >
              <span
                className={`${
                  props.value
                    ? "opacity-0 ease-out duration-100"
                    : "opacity-100 ease-in duration-200"
                } absolute inset-0 h-full w-full flex items-center justify-center transition-opacity`}
              >
                <svg
                  className="h-3 w-3 text-gray-400"
                  fill="none"
                  viewBox="0 0 12 12"
                >
                  <path
                    d="M4 8l2-2m0 0l2-2M6 6L4 4m2 2l2 2"
                    stroke="currentColor"
                    strokeWidth={2}
                    strokeLinecap="round"
                    strokeLinejoin="round"
                  />
                </svg>
              </span>
              <span
                className={`${
                  props.value
                    ? "opacity-100 ease-in duration-200"
                    : "opacity-0 ease-out duration-100"
                } absolute inset-0 h-full w-full flex items-center justify-center transition-opacity`}
              >
                <svg
                  className={`h-3 w-3 ${
                    props.readOnly || props.hasToPay
                      ? "text-gray-400"
                      : "text-purple-600"
                  }`}
                  fill="currentColor"
                  viewBox="0 0 12 12"
                >
                  <path d="M3.707 5.293a1 1 0 00-1.414 1.414l1.414-1.414zM5 8l-.707.707a1 1 0 001.414 0L5 8zm4.707-3.293a1 1 0 00-1.414-1.414l1.414 1.414zm-7.414 2l2 2 1.414-1.414-2-2-1.414 1.414zm3.414 2l4-4-1.414-1.414-4 4 1.414 1.414z" />
                </svg>
              </span>
            </span>
          </Switch>
        </div>
        {props.hasToPay && <PremiumFeature />}
      </div>
    </div>
  );
}
